/**
 * Buy/Extend (TPO_EXTEND) pricing helpers — single source for portal + tests + smoke script.
 * Extend flows charge 50% of the annual TPO tariff for the class (fresh 1-month segment and second half).
 */

/** Vehicle classes offered on the Buy/Extend TPO_EXTEND tile (CoverPurchase + App). */
const TPO_EXTEND_VEHICLE_CLASSES = [
  'Motor Private',
  'Motor Commercial',
  'Motor Commercial Institutional',
  'Motor Commercial General Cartage',
  'Tuk Tuk PSV',
  'PSV Chauffer Driven'
];

/** Multiplier applied to computed annual TPO premium for TPO_EXTEND (fresh + second half). */
function getTpoExtendAnnualPremiumFactor(coverType) {
  return coverType === 'TPO_EXTEND' ? 1 / 2 : 1;
}

/**
 * Pricing table rows for “start-new” extend (1 month DMVIC window): 50% of each matching 1Y TPO rate.
 * @param {Array<{ label: string, period: string, amount?: number, [k: string]: any }>} tpoPricing
 * @param {string[]} [classes=TPO_EXTEND_VEHICLE_CLASSES]
 */
function mapAnnualTpoRowsToFreshExtendMonthDisplay(tpoPricing, classes = TPO_EXTEND_VEHICLE_CLASSES) {
  return tpoPricing
    .filter((p) => p.period === '1 Year' && classes.includes(p.label))
    .map((p) => ({
      ...p,
      period: '1 Month',
      amount: Math.round(Number(p.amount || 0) * 0.5)
    }));
}

/**
 * Second-half extend table: 50% of annual, period label for UI.
 * @param {Array<{ label: string, period: string, amount?: number, [k: string]: any }>} tpoPricing
 * @param {string[]} [classes=TPO_EXTEND_VEHICLE_CLASSES]
 */
function mapAnnualTpoRowsToSecondHalfExtendDisplay(tpoPricing, classes = TPO_EXTEND_VEHICLE_CLASSES) {
  return tpoPricing
    .filter((p) => p.period === '1 Year' && classes.includes(p.label))
    .map((p) => ({
      ...p,
      period: '1 Year (50%)',
      amount: Math.round(Number(p.amount || 0) * 0.5)
    }));
}

/** Baseline annual (1Y) amounts from portal defaults — regression guard when API rates unchanged. */
const TPO_EXTEND_BASELINE_ANNUAL_BY_LABEL = {
  'Motor Private': 3300,
  'Motor Commercial General Cartage': 4155,
  'Motor Commercial Institutional': 4155,
  'Tuk Tuk PSV': 4155,
  'PSV Chauffer Driven': 5500
};

export {
  TPO_EXTEND_VEHICLE_CLASSES,
  getTpoExtendAnnualPremiumFactor,
  mapAnnualTpoRowsToFreshExtendMonthDisplay,
  mapAnnualTpoRowsToSecondHalfExtendDisplay,
  TPO_EXTEND_BASELINE_ANNUAL_BY_LABEL
};
